// ============================================================================
// On-site search index
// ----------------------------------------------------------------------------
// Lightweight, client-side searchable index of pages and key sections. The
// SearchDialog matches a query against title/description/keywords and lets the
// user jump straight to the relevant page (and anchor, where available).
// NOTE (Future CMS): this can later be generated from CMS content.
// ============================================================================

export interface SearchEntry {
  title: string;
  description: string;
  /** Route path, optionally including a #hash anchor. */
  path: string;
  keywords: string;
}

export const SEARCH_INDEX: SearchEntry[] = [
  {
    title: "Home",
    description: "Global clinical research site management & consulting.",
    path: "/",
    keywords: "home overview medcore research clinical trials sites",
  },
  {
    title: "About Us",
    description: "Who we are and how we bridge patient care and research.",
    path: "/about",
    keywords: "about company mission who we are consulting site management",
  },
  {
    title: "Services",
    description: "Support for sites, physicians, pharma, biotech, sponsors & CROs.",
    path: "/services",
    keywords:
      "services smo site management organization isf regulatory binder ethics submissions site staff training study coordination patient recruitment feasibility start-up site identification operational oversight compliance",
  },
  {
    title: "Services — For Sites & Physicians",
    description: "Research readiness, study matching, feasibility, coordination.",
    path: "/services#for-sites",
    keywords:
      "sites physicians research readiness study matching feasibility start-up coordination audit readiness",
  },
  {
    title: "Services — For Pharma, Biotech & CROs",
    description: "Site identification, start-up, management, recruitment & oversight.",
    path: "/services#for-pharma",
    keywords:
      "pharma biotech cro sponsor site identification start-up management recruitment retention quality oversight",
  },
  {
    title: "Therapeutic Areas",
    description: "Matching studies with site capabilities and physician interests.",
    path: "/therapeutic-areas",
    keywords:
      "therapeutic areas diabetes obesity cardiovascular diseases vaccines respiratory diseases dermatology pediatric women's health mental health",
  },
  {
    title: "Blogs",
    description: "Articles, insights, and updates from MedCore Research.",
    path: "/blogs",
    keywords: "blogs articles insights updates news posts guides",
  },
  {
    title: "Our Sites",
    description:
      "Research-ready community clinics with diverse patient populations and centralized SMO support.",
    path: "/our-sites",
    keywords:
      "our sites clinics network patients 10000 4000 visits multicultural recruitment retention infrastructure electronic medical records investigational product smo ich gcp",
  },
  {
    title: "Why GCP Certification Is Essential",
    description:
      "How Good Clinical Practice certification supports participant safety, data integrity, and trial quality.",
    path: "/blogs/why-gcp-certification-is-essential",
    keywords:
      "gcp good clinical practice certification participant safety data integrity compliance training ich health canada",
  },
  {
    title: "Contact Us",
    description: "Partner with MedCore Research — email, location, and business hours.",
    path: "/contact",
    keywords: "contact partner email location toronto ontario support hours",
  },
  {
    title: "Who We Serve",
    description: "Clinical sites & physicians, pharma/biotech/CROs, and partners.",
    path: "/#who-we-serve",
    keywords: "who we serve clinical sites physicians pharma biotech cros research partners",
  },
];

/** Filter the index for a query (case-insensitive substring across fields). */
export function searchEntries(query: string): SearchEntry[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const terms = q.split(/\s+/);
  return SEARCH_INDEX.filter((e) => {
    const haystack = `${e.title} ${e.description} ${e.keywords}`.toLowerCase();
    return terms.every((t) => haystack.includes(t));
  }).slice(0, 8);
}
